import type { IdmErrorMessageKeys } from '@login/helpers/idm-errors';

/**
 * IDM returns the same error titles for every account form, but each form
 * shows them through its own translation keys. Collecting them here keeps the
 * mapping in one place instead of inside each submit handler.
 */
export const REGISTER_ERROR_KEYS: IdmErrorMessageKeys = {
	usedEmail: 'register.email_used_error',
};

export const FULL_REGISTER_ERROR_KEYS: IdmErrorMessageKeys = {
	usedEmail: 'fullregister.email_used_error_full',
	usedMobile: 'fullregister.mobile_used_error_full',
};

export const REQUIRED_INFO_ERROR_KEYS: IdmErrorMessageKeys = {
	usedEmail: 'requiredinfo.email_used_error_info',
};

/** Visual order of the fields, used to scroll to the first one in error. */
export const REGISTER_FIELD_ORDER = [
	'birthDate',
	'dayOfBirth',
	'monthOfBirth',
	'yearOfBirth',
	'email',
	'password',
	'passwordConfirm',
	'marketingOptIn',
] as const;

export const FULL_REGISTER_FIELD_ORDER = [
	'birthDate',
	'dayOfBirth',
	'monthOfBirth',
	'yearOfBirth',
	'email',
	'password',
	'passwordConfirm',
	'firstName',
	'lastName',
	'address.countryCode',
	'address.addressLine1',
	'address.addressLine2',
	'address.addressLine3',
	'address.city',
	'address.postcode',
	'mobilePhone',
	'address.birthCountry',
	'address.birthCounty',
	'address.birthCity',
	'marketingOptIn',
] as const;

export const REQUIRED_INFO_FIELD_ORDER = [
	'birthDate',
	'dayOfBirth',
	'monthOfBirth',
	'yearOfBirth',
	'firstName',
	'lastName',
	'email',
	'address.countryCode',
	'address.addressLine1',
	'address.addressLine2',
	'address.addressLine3',
	'address.city',
	'address.postcode',
	'mobilePhone',
	'address.birthCountry',
	'address.birthCounty',
	'address.birthCity',
] as const;
